// ga 구매 성공 트래킹
export const useGooleAnalytics = () => {
  const getAccoutUserInfo = async () => {
    const { getUserAccountInfo } = useApi()
    const user: { data: any; success: boolean } = await getUserAccountInfo()
    const userInfo = {
      userId: user.data?.accountId || '-',
      userName: user.data?.userName || 'guest'
    }

    return userInfo
  }

  const sendCommonEvent = async () => {
    if (typeof window === 'undefined') return

    const user: { userId: string; userName: string } = await getAccoutUserInfo()
    window.dataLayer.push({
      user_id: user.userId || '-',
      name: user.userName || '-'
    })
  }

  const sendPurchaseEvent = async (data: any) => {
    if (typeof window === 'undefined') return

    await sendCommonEvent()

    window.dataLayer.push({
      event: 'purchase',
      transaction_id: data?.orderId || '-',
      currency: 'KRW',
      value: Number(data?.totalProductAmount) || 0,
      quantity: Number(data.productCount) || 1,
      price: String(data?.price) || '-',
      items: [
        {
          item_id: data?.planId || '-',
          item_name: data?.planName || '-'
        }
      ]
    })
  }

  const sendSignUpEvent = async () => {
    if (typeof window === 'undefined') return

    window.dataLayer.push({
      event: 'sign_up'
    })

    await sendCommonEvent()
  }

  return { sendCommonEvent, sendPurchaseEvent, sendSignUpEvent }
}
